import {ID} from '@datorama/akita';

export interface ShareStateEntityModel<T> {
  id: ID;
  loading: boolean;
  error: any;
  data: T;
}

export function getShareStateEntity<T>(id: ID, data: T = null, loading = false, error = null
): ShareStateEntityModel<T> {
  return {
    id,
    loading,
    error,
    data
  };
}
